import React, { useEffect, useState, useContext } from 'react'
import Athlete, { EmptyAthlete } from '../../models/Athletes';

import { Form, Input, Row, Col, DatePicker, Button, Select, Typography } from 'antd'

import { LoginContext } from '../../hooks/context/userContext'

import moment from "moment";
import 'moment/locale/es';
import locale from 'antd/es/date-picker/locale/es_ES';

import RestApiClient from '../../api/restApiClient';
import ParamsApi from '../../models/api/ParamsApi';
import ApiResponse from '../../models/api/ApiResponse';

const { Option } = Select;

interface InfoAthleteFormProps{
    onFinish: () => void
    athlete: Athlete
    onClose: () => void
}

const InfoAthleteFormComponent = (props : InfoAthleteFormProps) : JSX.Element => {
    
    const loginContext = useContext(LoginContext);

    const [form] = Form.useForm();

    const [athlete, setAthlete] = useState<Athlete>(EmptyAthlete);

    const restApiClient : RestApiClient = new RestApiClient();

    const onFinish = () => {
        

        const athleteData = form.getFieldsValue() as Athlete;
                  athleteData.idUser = loginContext.id;
                  athleteData.id = props.athlete.id;

        if (!athleteData.secondSurname){
            //El campo es obligatorio en el backend así que le ponemos un espacio en blanco
            athleteData.secondSurname = " ";
        }

        const paramsApi : ParamsApi = {
            body: athleteData
        }

        restApiClient.fetch("UpdateAthlete", paramsApi).then((r : ApiResponse | null)=> {
            if (r?.code === 200){
                // Limpiamos el formulario
                form.resetFields();
                
                props.onFinish();
                
            }
            
        });
        
        
    }

    useEffect(()=>{
        props.athlete.birthDate = moment(props.athlete.birthDate);
        setAthlete(props.athlete);
    }, [props.athlete])
    
    useEffect(()=>{
        form.setFieldsValue(athlete);
    }, [athlete])

    return (
        <Form layout="vertical" size="small" onFinish={onFinish} form={form} initialValues={athlete}>
            <Row gutter={20}>
                <Col xs={24}>
                    <Typography.Title level={5}>
                        Datos personales
                    </Typography.Title>
                </Col>
                <Col xs={24}>
                    Introduzca los datos de {athlete.name}
                </Col>
                <Col xs={24}>
                    <Form.Item
                        name="name"
                        label="Nombre"
                        className="form-item"
                        rules={[{required: true, message: 'Este campo es obligatorio'}]}
                    >
                        <Input placeholder="Nombre"/>
                    </Form.Item>
                    <Form.Item
                        name="surname"
                        label="Primer apellido"
                        className="form-item"
                        rules={[{required: true, message: 'Este campo es obligatorio'}]}
                    >
                        <Input placeholder="Primer apellido"/>
                    </Form.Item>
                    <Form.Item
                        name="secondSurname"
                        label="Segundo apellido"
                        className="form-item"
                    >
                        <Input placeholder="Segundo apellido"/>
                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <Typography.Title level={5}>
                        Otros datos
                    </Typography.Title>
                </Col>
                <Col xs={24}>
                    <Form.Item name="birthDate"
                        className="form-item"
                        label="Fecha de nacimiento"
                        rules={[{required: true, message: 'Este campo es obligatorio'}]}
                    >
                        <DatePicker format="DD/MM/YYYY" locale={locale}  placeholder="Fecha de nacimiento" style={{width: "100%"}} />
                    </Form.Item>
                    <Form.Item
                        name="dniNie"
                        className="form-item"
                        rules={
                            [
                                ({ getFieldValue }) => ({
                                    validator(rule, value) {
                                       const birthDate = getFieldValue('birthDate');

                                       if (value === undefined && birthDate  !== undefined && moment().diff(birthDate, 'years') >= 14){
                                           // yo también soy obligatorio
                                           return Promise.reject("Obligatorio para mayores de 14 años");
                                        }
                                       
                                       return Promise.resolve();
                                      
                                    },
                                  })
                            ]
                        }
                    >
                        <Input placeholder="DNI"/>
                    </Form.Item>
                    <Form.Item
                        name="relationship"
                        label="Parentesco"
                        className="form-item"
                        rules={[{required: true, message: 'Este campo es obligatorio'}]}
                        initialValue={athlete.relationship}
                    >
                        <Select placeholder="Indique relación">
                            <Option value="myself">Soy yo mismo</Option>
                            <Option value="fmolg">Soy su padre/madre, tutor/tutora o responsable legal</Option>
                            <Option value="couple">Soy su pareja</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <Form.Item className="btn-add-athlete">
                        <Button type="primary" danger onClick={props.onClose}>
                            Cancelar
                        </Button>
                        <Button type="primary" htmlType="submit" className="btn-save-athlete">
                            Actualizar
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
}

export default InfoAthleteFormComponent;